import { render, staticRenderFns } from "./BookingAssistant14.vue?vue&type=template&id=91a37020&scoped=true&lang=pug&"
import script from "./BookingAssistant14.vue?vue&type=script&lang=ts&"
export * from "./BookingAssistant14.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a37020",
  null
  
)

export default component.exports